import NumberFormat from 'react-number-format'
import { CSSProperties } from 'react'

const FieldWrapper: CSSProperties = {
    position: 'relative',
}

const TextInput: CSSProperties = {
    zIndex: 0,
    all: 'unset',
    display: 'block',
    border: '2px solid #000',
    borderRadius: '5px',
    backgroundColor: '#FFF',
    padding: '1.5em 1.5em',
    height: '35px',
    fontSize: '15px',
    lineHeight: '1em',
    width: '100%',
    boxSizing: 'border-box',
    color: '#000',
    transition: 'all .25s ease-out',
    // '&:focus': {
    //     borderColor: '#000',
    // },
}

const LabelStyles: CSSProperties = {
    zIndex: 1,
    padding: '0 0.3em',
    fontSize: '0.75em',
    top: '-0.6em',
    left: '0.9em',
    userSelect: 'none',
    position: 'absolute',
    backgroundColor: '#FFF',
    color: '#000',
    animation: `opacity 200ms`,
    transition: 'all .1s ease-out',
}

const hiddenLabelStyle: CSSProperties = {
    opacity: 0,
}

// TODO Set up TS interface

export const CardLinkTextInputWithLabel = (props: any) => {
    const {
        initialError,
        initialTouched,
        initialValue,
        touched,
        numFormat,
        value,
        label,
        placeholder,
        hasError,
        ...theRest
    } = props

    return (
        <div style={FieldWrapper}>
            {numFormat ? (
                <NumberFormat
                    format={numFormat}
                    style={TextInput}
                    value={value}
                    placeholder={placeholder ?? label}
                    {...theRest}
                />
            ) : (
                <input
                    style={TextInput}
                    value={value}
                    placeholder={placeholder ?? label}
                    // @TODO add error display
                    {...theRest}
                />
            )}
            <label
                htmlFor={props.name}
                style={
                    !value && !placeholder
                        ? { ...LabelStyles, ...hiddenLabelStyle }
                        : LabelStyles
                }
                // @ts-ignore
                //hidden={!value && !placeholder}
            >
                {label}
            </label>
        </div>
    )
}
